import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=2c20b7ed"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c20b7ed')) {
      api.createRecord('2c20b7ed', component.options)
    } else {
      api.reload('2c20b7ed', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=2c20b7ed", function () {
      api.rerender('2c20b7ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Logo.vue"
export default component.exports